module.exports = __webpack_public_path__ + "img/elvis-fanday-86.de74b831.jpg";